<template lang="pug">
//- .card-list
  card-input(v-model="cardInput" @added="addCard($event)")
  v-card
      v-card-title
        span Payment Cards
        v-btn(@click="cardInput = true") Add New
      v-card-text
        card-item(v-for="card in cards" :card="card" :key="card.id")

.card-list
  card-input(v-model="cardInput" @added="addCard($event)")
  v-layout.mb-2
    div.h6.s1.primary--text {{ $t('card_list') }}
    v-spacer
    v-btn.my-auto.px-3.button-AA-tiny(color="info500" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="cardInput = true")
      v-icon.ml-n2(left size=14) mdi-plus
      div.ml-n2.mr-n1  {{ $t('add_card') }}

  v-layout.my-6(v-if="isFetching")
    v-row.fill-height.ma-0(align='center' justify='center')
      v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

  .content-layout(v-else)
    v-card.mt-4(outlined)
      v-layout.ma-0.pt-2(v-if="cards.length == 0")
        div.mx-auto.my-11.text-center
          p.p2.primary400--text {{ $t('no_card') }}
      v-simple-table.mytable(v-else fixed-header)
        template(v-slot:default)
          thead
            tr
              th.text-left.primary400--text(style="background-color: #f7f7f7") {{ $t('card') }}
              th.text-left.primary400--text(style="background-color: #f7f7f7") {{ $t('expiry') }}
              th.text-center.primary400--text(style="background-color: #f7f7f7") {{ $t('actions') }}
          tbody
            card-item(v-for="(card, index) in cards" :index="index" :card="card" :key="card.id" @confirmDelete="confirmDelete($event)")

  .modals
    //- update-cash-payment(v-if="showUpdateCashDialog" :open.sync="showUpdateCashDialog" :company="company" :bank="editingBank" @added="handleAddItem" @edited="handleEditItem")
    y-dialog(v-model="deleteDialog" max-width="290")
      v-card
        v-card-title.h6 {{ $t('remove_card') }}
        v-card-text.p2.primary500--text
          | {{ $t('text_remove_card') }}
        v-card-actions
          v-spacer
          v-btn.button-Aa-small(color="grey" text @click="deleteDialog = false") {{ $t('cancel') }}
          v-btn.button-AA-medium(color="red" text @click="startDelete") {{ $t('remove') }}
</template>

<script>
import { mapActions } from 'vuex'
import CardItem from './CardItem'
import CardInput from './CardInput'
export default {
  name: "CardList",
  components: { CardItem, CardInput },
  data: () => ({
    isFetching: false,
    cardInput: false,
    cards: [],
    deleteDialog: false,
    editingCard: null
  }),
  computed: {
    primaryCard () {
      if (this.cards.length === 0) {
        return null
      } else if (this.cards.length === 1) {
        return this.cards[0]
      } else {
        return this.cards.filter(c => c.primary)[0]
      }
    }
  },
  watch: {
    cards () {
      this.$emit('change', this.primaryCard)
    }
  },
  mounted () {
    this.fetchCards()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCards () {
      this.isFetching = true
      this.$axios.get('/billing/cards/')
        .then(resp => {
          this.cards = resp.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    addCard (card) {
      this.showMessage(['success', this.$t('success_message.card_successfully_added')])
      this.cards.push(card)
    },
    confirmDelete (card) {
      this.editingCard = card
      this.deleteDialog = true
    },
    startDelete () {
      this.$axios.delete(`/billing/cards/${this.editingCard.id}/`)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.card_successfully_deleted')])
          this.deleteDialog = false
          this.cards.splice(this.cards.indexOf(this.editingCard), 1)
          this.editingCard = null
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_remove_card')])
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.mytable table th {
    background-color: #F7F7F7;
    border-bottom: none;
}
</style>

<i18n>
{
  "en": {
    "no_card": "No cards added yet",
    "text_remove_card": "Are you sure you want to remove this card?"
  },
  "id": {
    "no_card": "Belum ada kartu yang ditambahkan",
    "text_remove_card": "Anda yakin ingin menghapus kartu ini?"
  }
}
</i18n>